import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MuiThemeProvider, CssBaseline } from '@material-ui/core';
import { createTheme } from '@michelin/acid-components';

import Routes from './Routes';
import registerServiceWorker from './serviceWorker';

const theme = createTheme({
  palette: {
    type: 'michelinLightBC',
  },
});

/**
 * App is the component actually rendered to display the complete and functional application.
 * It is the SetupComponent, plus not-test-env friendly provider components, plus the router.
 * @param {object} props
 */
function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </MuiThemeProvider>
  );
}

export { registerServiceWorker };

export default App;
